// extracted by mini-css-extract-plugin
export default {"fieldContainer":"AddCategoryGroupModal_fieldContainer__Ke25+","label":"AddCategoryGroupModal_label__irH68","errorText":"AddCategoryGroupModal_errorText__mBh6K"};